export const AppPreview = () => (
  <section className="bg-[#F3EAE1]" data-testid="app-preview-section">
    <h2 className="sr-only" data-testid="app-preview-headline">
      Prepared for people who show up
    </h2>
    <p className="sr-only" data-testid="app-preview-overline">
      Quiet luxury section
    </p>
    <p className="sr-only">
      Space for clarity. Privacy for focus. Details for those who value them.
    </p>
    <div className="mx-auto w-full max-w-[1024px]">
      <img
        src="/assets/prepared-section.jpg"
        alt="Quiet cream interior with the headline Prepared for people who show up, a gold Quiet luxury section label, and the lines Space for clarity, Privacy for focus, and Details for those who value them. An envelope with a wax seal and a botanical notecard sit at the lower left. A cream phone for The Reserve Collective reads Ready when you are, beside a floating Reserve Member card with a gold botanical, Invisible standards. Lasting impression., Member since 05 / 2024, and a gold R monogram. A palm shadow falls on the wall."
        className="block h-auto w-full"
      />
    </div>
  </section>
);
